import React, { useEffect } from 'react'
import { Colors, ColorTypes, ThemeProvider } from 'styled-components'
import { scoreboardTheme } from 'theme'
import { authSelector } from 'shared/hocs/withAuth'
import { useSelector } from 'react-redux'
import { organizationSettingSelector } from 'shared/hocs/withAuth'

const ADMIN_PURPLE: Colors = {
  black: '#000000',
  lightBlue: '#EFF3F4',
  border: '#E0E0E0',
  label: '#919191',
  main: '#95358F',
  secondary: '#353535',
  white: '#FFFFFF',
  lightGrey: '#C0C0C0',
  inputBorder: '#DCDCDC',
  textLink: '#1573FF',
  darkMain: '#7B2276',
  tableAlternate: '#F9F3F8',
  focusShadow: '#95358F',
  caution: '#DD5151',
}

const ORGANIZATION_PINK: Colors = {
  black: '#000000',
  lightBlue: '#EFF3F4',
  border: '#E0E0E0',
  label: '#919191',
  main: '#CB5987',
  secondary: '#353535',
  white: '#FFFFFF',
  lightGrey: '#C0C0C0',
  inputBorder: '#DCDCDC',
  textLink: '#1573FF',
  darkMain: '#D0427B',
  tableAlternate: '#FBF4F7',
  focusShadow: '#CB5987',
  caution: '#DD5151',
}

const PARTICIPANT_GREEN: Colors = {
  black: '#000000',
  lightBlue: '#EFF3F4',
  border: '#E0E0E0',
  label: '#919191',
  main: '#008667',
  secondary: '#353535',
  white: '#FFFFFF',
  lightGrey: '#C0C0C0',
  inputBorder: '#DCDCDC',
  textLink: '#1573FF',
  darkMain: '#045F4A',
  tableAlternate: '#E8EEE9',
  focusShadow: '#008667',
  caution: '#DD5151',
}

const COACH_BLUE: Colors = {
  black: '#000000',
  lightBlue: '#EFF3F4',
  border: '#E0E0E0',
  label: '#919191',
  main: '#003074',
  secondary: '#353535',
  white: '#FFFFFF',
  lightGrey: '#C0C0C0',
  inputBorder: '#DCDCDC',
  textLink: '#1573FF',
  darkMain: '#052C64',
  tableAlternate: '#ECF0F4',
  focusShadow: '#003074',
  caution: '#DD5151',
}

const GRANTER_BLUE: Colors = {
  black: '#000000',
  lightBlue: '#EFF3F4',
  border: '#E0E0E0',
  label: '#919191',
  main: '#118EC6',
  secondary: '#353535',
  white: '#FFFFFF',
  lightGrey: '#C0C0C0',
  inputBorder: '#DCDCDC',
  textLink: '#1573FF',
  darkMain: '#137FAF',
  tableAlternate: '#E9F1F4',
  focusShadow: '#118EC6',
  caution: '#DD5151',
}

const SUPER_ADMIN_BLUE: Colors = {
  black: '#000000',
  lightBlue: '#EFF3F4',
  border: '#E0E0E0',
  label: '#919191',
  main: '#00B0FF',
  secondary: '#353535',
  white: '#FFFFFF',
  lightGrey: '#C0C0C0',
  inputBorder: '#DCDCDC',
  textLink: '#1573FF',
  darkMain: '#137FAF',
  tableAlternate: '#E9F1F4',
  focusShadow: '#00B0FF',
  caution: '#DD5151',
}

const PARENTS_MAGENTA: Colors = {
  black: '#000000',
  lightBlue: '#EFF3F4',
  border: '#E0E0E0',
  label: '#919191',
  main: '#AE0958',
  secondary: '#353535',
  white: '#FFFFFF',
  lightGrey: '#C0C0C0',
  inputBorder: '#DCDCDC',
  textLink: '#1573FF',
  darkMain: '#AE0958',
  tableAlternate: '#F5E6ED',
  focusShadow: '#AE0958',
  caution: '#DD5151',
}

const CRIMSON_RED: Colors = {
  black: '#000000',
  lightBlue: '#EFF3F4',
  border: '#E0E0E0',
  label: '#919191',
  main: '#BD0606',
  secondary: '#353535',
  white: '#FFFFFF',
  lightGrey: '#C0C0C0',
  inputBorder: '#DCDCDC',
  textLink: '#1573FF',
  darkMain: '#A60000 ',
  tableAlternate: '#F5ECEC',
  focusShadow: '#BD0606',
  caution: '#DD5151',
}

const SQUASH_ORANGE: Colors = {
  black: '#000000',
  lightBlue: '#EFF3F4',
  border: '#E0E0E0',
  label: '#919191',
  main: '#D35914',
  secondary: '#353535',
  white: '#FFFFFF',
  lightGrey: '#C0C0C0',
  inputBorder: '#DCDCDC',
  textLink: '#1573FF',
  darkMain: '#CC4A00',
  tableAlternate: '#FAEEE7',
  focusShadow: '#D35914',
  caution: '#DD5151',
}

const APRICOT_GOLD: Colors = {
  black: '#000000',
  lightBlue: '#EFF3F4',
  border: '#E0E0E0',
  label: '#919191',
  main: '#DA9001',
  secondary: '#353535',
  white: '#FFFFFF',
  lightGrey: '#C0C0C0',
  inputBorder: '#DCDCDC',
  textLink: '#1573FF',
  darkMain: '#CF8900',
  tableAlternate: '#FDF6E8',
  focusShadow: '#DA9001',
  caution: '#DD5151',
}

const FOREST_GREEN: Colors = {
  black: '#000000',
  lightBlue: '#EFF3F4',
  border: '#E0E0E0',
  label: '#919191',
  main: '#1FA153',
  secondary: '#353535',
  white: '#FFFFFF',
  lightGrey: '#C0C0C0',
  inputBorder: '#DCDCDC',
  textLink: '#1573FF',
  darkMain: '#118741',
  tableAlternate: '#E7EEEA',
  focusShadow: '#1FA153',
  caution: '#DD5151',
}

const DARK_CYAN: Colors = {
  black: '#000000',
  lightBlue: '#EFF3F4',
  border: '#E0E0E0',
  label: '#919191',
  main: '#089EA8',
  secondary: '#353535',
  white: '#FFFFFF',
  lightGrey: '#C0C0C0',
  inputBorder: '#DCDCDC',
  textLink: '#1573FF',
  darkMain: '#04858D',
  tableAlternate: '#E0E9EA',
  focusShadow: '#089EA8',
  caution: '#DD5151',
}

const COBALT_BLUE: Colors = {
  black: '#000000',
  lightBlue: '#EFF3F4',
  border: '#E0E0E0',
  label: '#919191',
  main: '#085BA8',
  secondary: '#353535',
  white: '#FFFFFF',
  lightGrey: '#C0C0C0',
  inputBorder: '#DCDCDC',
  textLink: '#1573FF',
  darkMain: '#02498B',
  tableAlternate: '#EFF4F8',
  focusShadow: '#085BA8',
  caution: '#DD5151',
}

const MIDNIGHT_BLUE: Colors = {
  black: '#000000',
  lightBlue: '#EFF3F4',
  border: '#E0E0E0',
  label: '#919191',
  main: '#2B3097',
  secondary: '#353535',
  white: '#FFFFFF',
  lightGrey: '#C0C0C0',
  inputBorder: '#DCDCDC',
  textLink: '#1573FF',
  darkMain: '#101686',
  tableAlternate: '#E9E9F1',
  focusShadow: '#2B3097',
  caution: '#DD5151',
}

const INDIGO_PURPLE: Colors = {
  black: '#000000',
  lightBlue: '#EFF3F4',
  border: '#E0E0E0',
  label: '#919191',
  main: '#5B2B97',
  secondary: '#353535',
  white: '#FFFFFF',
  lightGrey: '#C0C0C0',
  inputBorder: '#DCDCDC',
  textLink: '#1573FF',
  darkMain: '#49138D',
  tableAlternate: '#EBE5F2',
  focusShadow: '#5B2B97',
  caution: '#DD5151',
}

const VIOLET_PURPLE: Colors = {
  black: '#000000',
  lightBlue: '#EFF3F4',
  border: '#E0E0E0',
  label: '#919191',
  main: '#9216A6',
  secondary: '#353535',
  white: '#FFFFFF',
  lightGrey: '#C0C0C0',
  inputBorder: '#DCDCDC',
  textLink: '#1573FF',
  darkMain: '#89109C',
  tableAlternate: '#F3E7F4',
  focusShadow: '#9216A6',
  caution: '#DD5151',
}

const CERISE_PINK: Colors = {
  black: '#000000',
  lightBlue: '#EFF3F4',
  border: '#E0E0E0',
  label: '#919191',
  main: '#BB0488',
  secondary: '#353535',
  white: '#FFFFFF',
  lightGrey: '#C0C0C0',
  inputBorder: '#DCDCDC',
  textLink: '#1573FF',
  darkMain: '#B80084',
  tableAlternate: '#F8EEF5',
  focusShadow: '#BB0488',
  caution: '#DD5151',
}

const ROLE_COLORS: { [key in ColorTypes]: Colors } = {
  '#95358F': ADMIN_PURPLE,
  '#CB5987': ORGANIZATION_PINK,
  '#008667': PARTICIPANT_GREEN,
  '#003074': COACH_BLUE,
  '#118EC6': GRANTER_BLUE,
  '#00B0FF': SUPER_ADMIN_BLUE,
  '#AE0958': PARENTS_MAGENTA,
  '#BD0606': CRIMSON_RED,
  '#D35914': SQUASH_ORANGE,
  '#DA9001': APRICOT_GOLD,
  '#1FA153': FOREST_GREEN,
  '#089EA8': DARK_CYAN,
  '#085BA8': COBALT_BLUE,
  '#2B3097': MIDNIGHT_BLUE,
  '#5B2B97': INDIGO_PURPLE,
  '#9216A6': VIOLET_PURPLE,
  '#BB0488': CERISE_PINK,
}

const Theme = (props: any) => {
  const currentUser = useSelector(authSelector)
  const { organization_information } = useSelector(organizationSettingSelector)
  const roleColor = ROLE_COLORS[currentUser.auth?.role_scheme?.main ?? '#95358F']
  const theme = { ...scoreboardTheme, colors: roleColor }

  useEffect(() => {
    if (organization_information && organization_information.name) document.title = organization_information.name
  }, [organization_information, document.title])

  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
}

export default Theme
